import { FC, memo } from 'react'
import { createIcon, IconProps } from '@chakra-ui/icons'

import CustomIcon from '../../CustomIcon'

const NurseIcon = createIcon({
  displayName: 'NurseIcon',
  viewBox: '0 0 24 24',
  path: (
    <>
      <line
        x1="14.10101"
        y1="13.405"
        x2="15.00001"
        y2="16"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      />
      <line
        x1="9.90101"
        y1="13.405"
        x2="9.00001"
        y2="16"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      />
      <path
        d="M21,21V19.54138A3,3,0,0,0,18.4932,16.5822L15,16l-3,3L9,16l-3.4932.5822A3,3,0,0,0,3,19.54138V21"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      />
      <line
        x1="12.00001"
        y1="21"
        x2="12.00001"
        y2="19"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      />
      <path
        d="M19,16.71376V8.5a7,7,0,0,0-7-7h0a7,7,0,0,0-7,7v8.214"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      />
      <path
        d="M8,8.00011l1.764,0A3.61807,3.61807,0,0,0,13,6.00011V6l.10557.21115A3.23607,3.23607,0,0,0,16,8h0"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      />
      <line
        x1="15.5"
        y1="20.75"
        x2="17.5"
        y2="20.75"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      />
      <path
        d="M16,8v2a4,4,0,0,1-4,4h0a4,4,0,0,1-4-4V8"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      />
      <path d="M0,0H24V24H0Z" fill="none" />
    </>
  ),
})

const Nurse: FC<IconProps> = (props) => {
  return <CustomIcon as={NurseIcon} {...props} />
}

export default memo(Nurse)
